// Build data
const { backendUrl } = require('../rv_data.js') || {}
// Vue
import Vue from 'vue'
import Router from 'vue-router'
import store from './store.js'
Vue.use(Router)

const routes = [
  {
    path: '*',
    redirect: { name: 'not-found' }
  },
  {
    path: '/',
    component: () => import(/* webpackChunkName: "all" */ './views/All.vue'),
    children: [
      {
        path: '/404',
        name: 'not-found',
        exempt: true,
        component: () => import(/* webpackChunkName: "404" */ './views/Page404.vue'),
      },
      {
        path: '/',
        name: 'home',
        component: () => import(/* webpackChunkName: "home" */ './views/Home.vue'),
        meta: {
          requirements: ['homePage'],
        },
      },
      {
        path: '/main-menu',
        name: 'main-menu',
        component: () => import(/* webpackChunkName: "main-menu" */ './views/MainMenu.vue'),
        meta: {
          requirements: ['mainMenuPage'],
        },
      },
      {
        path: '/areas-of-interest',
        name: 'area-of-interest',
        component: () => import(/* webpackChunkName: "area-of-interest" */ './views/AreaOfInterest.vue'),
        meta: {
          requirements: ['aoiPage'],
        },
      },
      {
        path: '/areas-of-interest/:aoi_id',
        name: 'aoi-sublevel',
        component: () => import(/* webpackChunkName: "aoi-sublevel" */ './views/AreaOfInterest.vue'),
        meta: {
          requirements: ['routeAoi'],
        },
      },
      // For Articles, Videos, and Galleries
      {
        path: '/areas-of-interest/:aoi_id/:media_id',
        name: 'aoi-media',
        component: () => import(/* webpackChunkName: "aoi-media" */ './views/Media.vue'),
        meta: {
          requirements: ['routeAoi', 'routeMedia'],
        },
      },
      // For Groups and Single-access 360s
      {
        path: '/areas-of-interest/:aoi_id/:media_id/:panorama_id',
        name: 'aoi-panorama',
        component: () => import(/* webpackChunkName: "aoi-panorama" */ './views/Media.vue'),
        meta: {
          requirements: ['routeAoi', 'routePanorama'],
        },
        children: [
          // For contentspots
          {
            path: ':contentspot_id',
            name: 'aoi-contentspot',
            component: () => import(/* webpackChunkName: "aoi-contentspot" */ './views/Contentspot.vue'),
            meta: {
              requirements: ['routeAoi', 'routePanorama', 'routeContentspot'],
            },
          },
        ]
      },

      // For Groups and Single-access 360s
      {
        path: '/guided-tour',
        name: 'guided-tour',
        component: () => import(/* webpackChunkName: "guided-tour" */ './views/GuidedTour.vue'),
        meta: {
          requirements: ['routeGuidedTour'],
        },
      },
      {
        path: '/guided-tour/:panorama_id',
        name: 'gt-panorama',
        component: () => import(/* webpackChunkName: "gt-panorama" */ './views/Media.vue'),
        meta: {
          requirements: ['routeGuidedTour', 'routePanorama'],
        },
        children: [
          // For contentspots
          {
            path: ':contentspot_id',
            name: 'gt-contentspot',
            component: () => import(/* webpackChunkName: "gt-contentspot" */ './views/Contentspot.vue'),
            meta: {
              requirements: ['routeGuidedTour', 'routePanorama', 'routeContentspot'],
            },
          }
        ]
      },
      // Just explore - Map
      {
        path: '/just-explore/',
        name: 'je-map',
        component: () => import(/* webpackChunkName: "je-map" */ './views/Campus.vue'),
      },
      // Just explore - Single-access 360s
      {
        path: '/just-explore/:media_id/:panorama_id',
        name: 'je-panorama',
        component: () => import(/* webpackChunkName: "je-panorama" */ './views/Media.vue'),
        meta: {
          requirements: ['routeJustExplore', 'routePanorama'],
        },
        children: [
          // For contentspots
          {
            path: ':contentspot_id',
            name: 'je-contentspot',
            component: () => import(/* webpackChunkName: "je-contentspot" */ './views/Contentspot.vue'),
            meta: {
              requirements: ['routeJustExplore', 'routePanorama', 'routeContentspot'],
            },
          }
        ]
      },
      // Direct pages
      {
        path: '/direct',
        redirect: {
          name: 'home'
        }
      },
      {
        path: '/direct/:direct_slug',
        name: 'direct',
        component: () => import(/* webpackChunkName: "direct" */ './views/Direct.vue'),
        meta: {
          requirements: ['routeDirectPage'],
        },
      },
      // For Articles, Videos, and Galleries
      {
        path: '/direct/:direct_slug/:media_id',
        name: 'direct-media',
        component: () => import(/* webpackChunkName: "direct-media" */ './views/Media.vue'),
        meta: {
          requirements: ['routeDirectPage', 'routeMedia'],
        },
      },
      // For Groups and Single-access 360s
      {
        path: '/direct/:direct_slug/:media_id/:panorama_id',
        name: 'direct-panorama',
        component: () => import(/* webpackChunkName: "direct-panorama" */ './views/Media.vue'),
        meta: {
          requirements: ['routeDirectPage', 'routePanorama'],
        },
        children: [
          // For contentspots
          {
            path: ':contentspot_id',
            name: 'direct-contentspot',
            component: () => import(/* webpackChunkName: "direct-contentspot" */ './views/Contentspot.vue'),
            meta: {
              requirements: ['routeDirectPage', 'routePanorama', 'routeContentspot'],
            },
          },
        ]
      },
    ]
  },
]

const router = new Router({
  mode: 'history',
  routes
})

const handleRouteChange = (to, from, next) => {
  const toName = to.name
  const fromName = from.name
  store.commit('menuModalOpen', false)
  store.commit('route', to)
  // ==========================================
  // Validate routes
  // ==========================================
  const { meta } = to
  const { requirements } = meta || {}
  const validRequirementsArr = requirements || []
  const hasRequirements = validRequirementsArr.length > 0
  const filteredRequirements = hasRequirements && requirements
    .filter(getterKey => store.getters[getterKey])
    .filter(Boolean)
  const requirementsMet = hasRequirements ? filteredRequirements.length > 0 : true
  if (requirementsMet) {
    next()
  } else {
    next({ name: 'not-found' })
  }
  // ==========================================
  // Just Explore - Back route
  // ==========================================
  if (fromName && toName) {
    if(from) {
      store.commit('justExploreBack', from)
    }
    // const comingFromJustExplore = ['je-panorama', 'je-contentspot'].includes(fromName)
    // const goingToJustExplore = toName === 'je-panorama'
    // if (!comingFromJustExplore && goingToJustExplore) {
    //   store.commit('justExploreBack', from)
    // } else if (!goingToJustExplore && comingFromJustExplore) {
    //   store.commit('justExploreBack')
    // }
  }
}

const fetches = (to, next) => {
  const restUrls = [
    `${backendUrl}rv/v1/basis?per_page=-1`,
    `${backendUrl}acf/v3/options/site-options`,
    `${backendUrl}acf/v3/options/admin-settings`,
  ]
  const promiseArr = restUrls.map( url => fetch( url ).then(out => out.json()) )
  // What to do with results
  const fetchThen = ([basis, options, settings]) => {
    store.commit('populate', {
      basis,
      options,
      settings,
    })
    handleRouteChange(to, '', next)
    store.commit('endLoading')
  }
  // Error
  const fetchCatch = (errorText) => {
    // Already looks like text, but Error is a type
    store.commit('setError', errorText.toString())
    store.commit('endLoading')
  }
  // Execute
  Promise.all( promiseArr )
    .then( fetchThen )
    .catch( fetchCatch )
}

router.beforeEach((to, from, next) => {
  const { state } = store
  const { posts } = state || {}
  //
  if (posts.length) {
    handleRouteChange(to, from, next)
  } else {
    fetches(to, next)
  }
})

export default router
